import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useSendBespokeInvoiceMutation } from '@/react-query/mutations/trades'

import { type SchemaType, schema } from './SendBespokeInvoiceForm.schema'

export interface SendBespokeInvoiceFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const SendBespokeInvoiceForm: React.FC<SendBespokeInvoiceFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const sendBespokeInvoiceMutation = useSendBespokeInvoiceMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await sendBespokeInvoiceMutation.mutateAsync({ value_date: _data.value_date })
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
